import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  role: [],
  data:{
    trend: [],
    dashboard_rows_flow_rate_report_device_value_trend: [],
    dashboard_rows_totalizer_report_device_value_trend: [],
    dashboard_rows_listdata_report_device_value_trend: [],
    usersCount: {
      series: [
        {
          name: 'Users',
          data: [20, 10, 30, 15, 20, 10, 25],
        },
      ],
      analyticsData: {
        users: 0,
      },
    },
    talentsCount: {
      series: [
        {
          name: 'Talents',
          data: [28, 40, 36, 52, 38, 60, 55],
        },
      ],
      analyticsData: {
        talents: 0,
      },
    },
    recruitersCount: {
      series: [
        {
          name: 'Recruiters',
          data: [10, 15, 8, 15, 7, 12, 8],
        },
      ],
      analyticsData: {
        recruiters: 0,
      },
    },
    postsCount: {
      series: [
        {
          name: 'Post',
          data: [10, 15, 8, 15, 7, 12, 8],
        },
      ],
      analyticsData: {
        posts: 0,
      },
    },
    supportTracker: {
      title: 'Transactions Tracker',
      // lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
      sumtransactions: 0,
      transactions: 0,
      jobs: 0,
      responseTime: 0,
      supportTrackerRadialBar: {
        series: [100],
      },
    },
  },
  fields: [
    {
      key: 'id', label: 'Id',
    },
    {
      key: 'photo', label: 'Photo',
    },
    // { key: 'full_name', label: 'Full Name', sortable: true },
    // { key: 'post', label: 'Post', sortable: true },
    'nickname',
    'invoice',
    'date',
    'amount',
    'type',
    { key: 'status', label: 'Status', sortable: true },
  ],
  items: [
    {
      id: 1,
      // eslint-disable-next-line global-require
      photo: require('@/assets/images/avatars/10-small.png'),
      nickname: "Korrie O'Crevy",
      invoice: 'kocrevy0@thetimes.co.uk',
      date: 'Krasnosilka',
      amount: '09/23/2016',
      type: '$23896.35',
      status: '61'
    }
  ],
  totalRows:0,
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }, params) {
    let param = {status: `internal/temperature/device/trend/${params.device_id}/F/${params.datestart}/${params.datefinish}`}
    useIPA.getInternal(param).then(response => {
      const dashboard = {
        rows : response.data.data,
      }
      commit('setData', {...dashboard})
    })
  },
  getTrx ({ commit }) {
    let param = {status: 'report/transaction'}
    useIPA.get(param).then(response => {
      const transaction = {
        rows : response.data.data
      }
      commit('setDataTrx', {...transaction})
    })
  }
}

// mutations
const mutations = {
  setData (state, dashboard) {
    // console.log(dashboard.rows)
    state.data.trend = dashboard.rows
    // state.data.dashboard_rows_flow_rate_report_device_value_trend = dashboard.rows.flow_rate.report_device_value_trend
    // state.data.dashboard_rows_totalizer_report_device_value_trend = dashboard.rows.totalizer.report_device_value_trend
    // state.data.dashboard_rows_list_data_report_device_value_trend = dashboard.rows.list_data.report_device_value_trend
    // state.data.usersCount.analyticsData.users = dashboard.rows.report_count_user
    // state.data.talentsCount.analyticsData.talents = dashboard.rows.report_count_talent
    // state.data.recruitersCount.analyticsData.recruiters = dashboard.rows.report_count_recruiter
    // state.data.postsCount.analyticsData.posts = dashboard.rows.report_count_post
    // state.data.supportTracker.jobs = dashboard.rows.report_count_job
    // state.data.supportTracker.transactions = dashboard.rows.report_count_transaction
    // state.data.supportTracker.sumtransactions = dashboard.rows.report_sum_transaction.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  },
  setDataTrx (state, transaction) {
    state.items = transaction.rows
    state.totalRows = transaction.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
